import { render, staticRenderFns } from "./CartTotalsList.vue?vue&type=template&id=7a1fd5d6"
import script from "./CartTotalsList.vue?vue&type=script&lang=js"
export * from "./CartTotalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports